import React from 'react';
export const StructuredData = ({ json }) => {
    return (React.createElement("script", { "data-testid": "structured-data", type: "application/ld+json", dangerouslySetInnerHTML: {
            __html: JSON.stringify(json)
        } }));
};
//# sourceMappingURL=StructuredData.js.map